

import React from 'react';
import partnerVideo from '../img/envision/automotivemobility/banking1.mp4'; // Replace with the correct path to your video file

const DocumetBfsibanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                   flexDirection: 'column',
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center' }}>Empowering Regulatory compliant and<br></br> resilient solutions for global</h1>
                {/* <p>Enabling Network Transformation and Empowering Autonomous Operations</p> */}
            </div>

            {/* Video */}
            <video
                src={partnerVideo}
                alt="partner video"
                autoPlay
                loop
                muted
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover', // This will ensure the video covers the area without stretching
                }}
            />
        </div>
    );
};

export default DocumetBfsibanner;


